/* eslint-disable react/prop-types */
import styled from 'styled-components';
import React from 'react';
import ds from 'designsystem';
import { media } from 'designsystem/index';
import LanguageLink from '../../../elements/LanguageLink';

const TagContainer = styled.div`
  position: relative; 
  width: 50%;
  height: ${ds.get('metrics.m')};
  display: inline-block;  
  
  ${media.tablet`
    height: ${ds.get('navSection.navHeight')};
  `}

  ${media.desktop`
    width: 200px;`}
`;

const TagContainerLink = styled(LanguageLink)`
  position: relative; 
  width: 50%;
  height: ${ds.get('metrics.m')};
  display: inline-block;  
  text-decoration: none;

  ${media.tablet`
    height: ${ds.get('navSection.navHeight')};
  `}

  ${media.desktop`
    width: 200px;`}
`;

const TagFlexContainer = styled.a`
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;    
    text-decoration: none;
    color: ${ds.get('colors.brand.white')}; 
    cursor: pointer;
    font-size: ${ds.fs('base')};
    font-family: ${ds.get('type.fontFamily.text')};
    font-weight: ${ds.get('type.fontWeight.light')};
    background-color: ${ds.get('colors.brand.product')};   
`;

const renderContent = children => (
  <TagFlexContainer>
    {children}
  </TagFlexContainer>
);

const TagAGetTheApp = ({
  to,
  onClick,
  children,
  ...reset
}) => (to ? (
  <TagContainerLink
    to={to}
    onClick={onClick}
    {...reset}
  >
    {renderContent(children)}
  </TagContainerLink>
) : (
  <TagContainer
    onClick={onClick}
    {...reset}
  >
    {renderContent(children)}
  </TagContainer>
)
);


export default TagAGetTheApp;



// WEBPACK FOOTER //
// ./src/blocks/Navigation/Buttons/TagAGetTheApp.jsx